// src/redux/slices/iframeSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  iframeUrl: null,
  appid: null,
};

const iframeSlice = createSlice({
  name: "iframe",
  initialState,
  reducers: {
    setIframeUrl: (state, action) => {
      state.iframeUrl = action.payload;
    },
    setIframeAppid: (state, action) => {
      state.appid = action.payload;
    },
    clearIframeUrl: (state) => {
      state.iframeUrl = null;
      state.appid = null;
    },
  },
});

export const { setIframeUrl, setIframeAppid, clearIframeUrl } = iframeSlice.actions;
export default iframeSlice.reducer;
